<template lang="pug">
  .container
    .columns.is-vcentered
      .column.is-6
        .field
          label.label Vehículo
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="vehiculoSel" :disabled="isDisabled")
                  option(v-for="v in vehiculos" :key="v.id" :value="v") {{ `${v.tipo} - ${v.descripcion} | ${v.placas}` }}
              .icon.is-small.is-left
                i.far.fa-user
    .columns.is-vcentered
      .column.is-2
        .field
          label.label Próximo Servicio
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='100,000',
                v-model="servicio",
                :disabled="isDisabled"
              )
      .column.is-2
        .field
          label.label Año de Vehículo
            .control.has-icons-left.has-icons-right
              input.input.is-primary(
                type='text', 
                placeholder='2020',
                v-model="year",
                :disabled="isDisabled"
              )
      .column.is-3
        .field
          label.label Verificación Mes
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="verificacionM" :disabled="isDisabled")
                  option(v-for="p in periodo" :key="p.id" :value="p") {{ p.nombre }}
              .icon.is-small.is-left
                i.far.fa-credit-card
      .column.is-2
        .field
          label.label Verificación Año
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="verificacionA" :disabled="isDisabled")
                  option(v-for="y in years" :key="y.id" :value="y") {{ y.nombre }}
              .icon.is-small.is-left
                i.far.fa-credit-card
      .column.is-2
        .field
          label.label Tipo Verificación
            .control.has-icons-left
              .select.is-primary.is-rounded
                select(v-model="tipoVerificacion" :disabled="isDisabled")
                  option(v-for="t in tiposVerificacion" :key="t.id" :value="t") {{ t.nombre }}
              .icon.is-small.is-left
                i.far.fa-credit-card
    .columns
      .column(v-show="!existeInBD")
        a.button.is-black.is-rounded(@click="checkForm")
          | Guardar Información
      .column(v-show="existeInBD")
        a.button.is-primary.is-rounded(@click="updateForm")
          | Actualizar Información
    .columns(v-show="Object.keys(datosFaltantes).length > 0")
      .notification
        .field.is-grouped.is-grouped-multiline
          .control(v-for="datosF in datosFaltantes")
            .tags
              span.tag.is-danger.is-light {{ datosF }}
    .columns.column-blanco
</template>

<script>
  import InventarioServices from '@/services/inventario/inventario'

  export default {
    name: 'FormVehiculo',
    props: {
      vehiculos: {
        type: Array,
        default: []
      },
    },
    data() {
      return {
        servicio: null,
        year: null,
        periodo: [
          { id: 1, value: '01-02', nombre: 'ENERO - FEBRERO' },
          { id: 2, value: '03-04', nombre: 'MARZO - ABRIL' },
          { id: 3, value: '05-06', nombre: 'MAYO - JUNIO' },
          { id: 4, value: '07-08', nombre: 'JULIO - AGOSTO' },
          { id: 5, value: '09-10', nombre: 'SEPTIEMBRE - OCTUBRE' },
          { id: 6, value: '11-12', nombre: 'NOVIEMBRE- DICIEMBRE' }
        ],
        years: [
          { id: '2020', nombre: '2020'},
          { id: '2021', nombre: '2021'},
          { id: '2022', nombre: '2022'},
          { id: '2023', nombre: '2023'},
          { id: '2024', nombre: '2024'},
          { id: '2025', nombre: '2025'},
          { id: '2026', nombre: '2026'},
          { id: '2027', nombre: '2027'},
          { id: '2028', nombre: '2028'},
          { id: '2029', nombre: '2029'},
          { id: '2030', nombre: '2030'}
        ],
        verificacionM: null,
        verificacionA: null,
        vehiculoSel: {},
        datosFaltantes: [],
        isDisabled: false,
        existeInBD: false,
        idVehiculoBD: null,
        tiposVerificacion: [
          { id: 'G', nombre: 'GENERAL'},
          { id: '0', nombre: '0'},
          { id: '00', nombre: '00'},
        ],
        tipoVerificacion: {},
      }
    },
    watch: {
      vehiculoSel() {
        this.checkData()
      }
    },
    methods: {
      checkForm () {
        this.datosFaltantes = []
        if (Object.keys(this.vehiculoSel).length > 0 && this.servicio && this.year && this.verificacionM && this.verificacionA) {
          this.saveForm()
        } else {
          if(Object.keys(this.vehiculoSel).length == 0) {
            this.datosFaltantes.push('El vehículo es requerido.')
          }

          if (!this.servicio) {
            this.datosFaltantes.push('El Próximo servicio es requerido.')
          }

          if (!this.year) {
            this.datosFaltantes.push('El Año del vehículo es requerido.')
          }
          if (!this.verificacionM) {
            this.datosFaltantes.push('El Mes de verificación es requerido.')
          }
          if (!this.verificacionA) {
            this.datosFaltantes.push('El Año de verificación es requerido.')
          }
        }
      },
      saveForm() {
        console.log('Save Form')
        let intTipo = 0
        switch (this.vehiculoSel.categoria) {
          case 'AUTOMOVIL':
            intTipo = 1
            break
          case 'CAMIONETA':
            intTipo = 2
            break
          case 'VAN':
            intTipo = 3
            break
          case 'TRACTOR':
            intTipo = 4
            break
        
          default:
            intTipo = 0
            break
        }

        let myObj = {
          id_articulo: this.vehiculoSel.id,
          placas: this.vehiculoSel.serie,
          proximoServicio: parseInt(this.servicio),
          verificacion: `${this.verificacionA.nombre}-${this.verificacionM.value}`,
          tipoStr: this.vehiculoSel.categoria,
          tipo: intTipo,
          modelo: `${this.vehiculoSel.marca} ${this.vehiculoSel.modelo}`,
          anio: parseInt(this.year),
          tipoVerificacion: this.tipoVerificacion.id,
        }

        this.$emit('saveForm', myObj)
      },
      checkData () {
        this.existeInBD = false
        InventarioServices.getVehiculoWithData(this.vehiculoSel.id_articulo)
          .then((data) => {
            if (data.length > 0) {
              const vehiculo = data[0]
              console.log(vehiculo)
              this.verificacionM = this.periodo.find( p => p.value === vehiculo.verificacionM)
              this.verificacionA = this.years.find( y => y.nombre === vehiculo.verificacionA)
              this.servicio = vehiculo.proximoServicio
              this.year = vehiculo.anio
              this.idVehiculoBD = vehiculo.id
              this.tipoVerificacion = this.tiposVerificacion.find( tv => tv.id === vehiculo.tipo_verificacion)
              this.existeInBD = true
              console.log(this.tipoVerificacion)
            } else {
              this.existeInBD = false
            }
          })
          .catch((e) => console.log(e))
      },
      updateForm() {
        let verif = `${this.verificacionA.nombre}-${this.verificacionM.value}`
        let myObj = {
          id: this.idVehiculoBD,
          servicio: this.servicio,
          verificacion: verif,
          year: this.year,
          tipoVerificacion: this.tipoVerificacion.id,
        }
        
        this.$emit('updateForm', myObj)
        this.limpiarform()
        this.vehiculoSel = {}
      },
      limpiarform () {
        this.idVehiculoBD = null
        this.servicio = null
        this.year = null
        this.verificacionM = null
        this.verificacionA = null
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/FormVehiculo.vue